import React from 'react'
import { useDispatch } from 'react-redux';
import { privacySwitch } from '../../reducers/ToggleAction';
import "./popUp.css"
import { AiOutlineClose } from "react-icons/ai"

const Privacy = () => {

  const dispatch = useDispatch();
        
  

  return (
    <div  id='popup'>
      
     <div  id="popup-div">
     <div id='popup-head' >
      <p id='close-div' className='flex justify-end'>
        <span onClick={()=>dispatch(privacySwitch())}><AiOutlineClose color='black' /></span>
        </p>
          <h2 className='border-l-0  text-black'>Privacy Policy</h2>
          <p>Vwrap is committed to protecting your privacy. This Privacy Policy describes how we collect, use, and disclose information that we may obtain about you through your use of the Vwrap website (the "Website"). By using the Website, you agree to the terms of this Privacy Policy.</p>
     </div>
     <div id='popup-body'>
      <h3>1- <span>COLLECTION OF INFORMATION</span></h3>
       <p>We may collect the following information from you when you use the Website:
        <ul>
         <br/>
            <li>- Personal information: such as your name, email address, phone number, and any other information you provide to us.</li>
            <li>- Usage information: such as your IP address, browser type, operating system, and information about how you interact with the Website.</li>
            <li>- Cookies: we may use cookies or similar technologies to collect information about your use of the Website.</li>
        </ul>
       </p>
      
      <h3>2- USE OF INFORMATION</h3>
      <p>We may use the information we collect from you for the following purposes:
      <ul>
         <br/>
            <li>- To provide you with the services and information you request from us.</li>
            <li>- To improve the Website and our services.</li>
            <li>- To communicate with you about the Website and our services.</li>
            <li>- To comply with legal obligations.</li>
        </ul>
      </p>


      <h3>3- DISCLOSURE OF INFORMATION</h3>
      <p>We may disclose your information in the following circumstances:
      <ul>
         <br/>
            <li>- With your consent.</li>
            <li>- To our service providers who help us to provide the Website and our services.</li>
            <li>- To comply with legal obligations, such as responding to subpoenas, court orders, or other legal processes.</li>
            <li>- In connection with a merger, acquisition, or sale of all or a portion of our assets.</li>
        </ul>
      </p>

      <h3>4- SECURITY</h3>
      <p>We take reasonable measures to protect the information we collect from you from unauthorized access, use, or disclosure. However, we cannot guarantee that your information will be completely secure..</p>


      <h3>5- YOUR RIGHTS</h3>
      <p>You have certain rights with respect to your personal information, including the right to access, correct, delete, or restrict the use of your information. You may also have the right to object to the processing of your personal information or to receive a copy of your information in a machine-readable format. To exercise these rights, please contact us using the contact information below.</p>


      <h3>6- CHANGES TO THIS PRIVACY POLICY</h3>
      <p>We may update this Privacy Policy from time to time. Any changes will be effective immediately upon posting of the updated Privacy Policy on the Website.</p>


      <h3>7- CONTACT US</h3>
      <p>If you have any questions or concerns about this Privacy Policy or our privacy practices, please contact us at the following email address: info@vwrap.com.</p>




     </div>
     </div>
    </div>
  )
}

export default Privacy
